export const LOGO_FULL =
  "https://customer-assets-0z36b82j.emergentagent.net/job_0fd24573-ea78-487f-9fe7-a3aa34017219/artifacts/7hwb79fb_241E6C7B-56CB-40A7-8C7D-CD176F33659B.jpeg";

export const LOGO_ICON =
  "https://customer-assets-0z36b82j.emergentagent.net/job_0fd24573-ea78-487f-9fe7-a3aa34017219/artifacts/yfid0ywz_D5193FC2-20CF-4328-A0BA-B85C854A2279.jpeg";

export const HERO_IMG =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_namur-aviation/artifacts/l0eqrqew_DD32CE42-7456-4366-B142-33E92F82D82B.png";

export const FLEET = [
  {
    id: "r22",
    name: "Robinson R22",
    subtitle: "Biplace · Instruction & découverte",
    capacity: "1 pilote + 1 passager",
    weight: "Poids stagiaire max. 90 kg",
    base: "Aérodrome de Namur",
    image:
      "https://customer-assets-39nsmqrw.emergentagent.net/job_namur-aviation/artifacts/z87nixoh_B55997FC-21E0-4756-B693-B6419CBEB196.png",
    description:
      "L'hélicoptère école de référence. Léger, précis, taillé pour l'initiation au pilotage et les baptêmes.",
    specs: [
      { k: "Motorisation", v: "Lycoming O-360" },
      { k: "Vitesse de croisière", v: "160 km/h" },
      { k: "Autonomie", v: "~3 h" },
    ],
  },
  {
    id: "r44",
    name: "Robinson R44",
    subtitle: "Quatre places · Polyvalent",
    capacity: "1 pilote + 3 passagers",
    weight: "Poids max. 120 kg / pers.",
    base: "Aérodrome de Namur",
    image:
      "https://images.pexels.com/photos/16872401/pexels-photo-16872401.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600",
    description:
      "Confortable, rapide, idéal pour un baptême à plusieurs ou une initiation avec accompagnants.",
    specs: [
      { k: "Motorisation", v: "Lycoming IO-540" },
      { k: "Vitesse de croisière", v: "210 km/h" },
      { k: "Autonomie", v: "~3 h 30" },
    ],
  },
  {
    id: "as350",
    name: "Eurocopter AS350",
    subtitle: "Écureuil · Turbine haut de gamme",
    capacity: "1 pilote + 5 passagers",
    weight: "150 kg par passager",
    base: "Aérodrome de Namur",
    image:
      "https://customer-assets-39nsmqrw.emergentagent.net/job_namur-aviation/artifacts/ih5z5oln_54648DA2-9E49-42EF-8226-30A112F6A3B1.png",
    description:
      "L'appareil des grandes occasions. Vols VIP, mariages, transports restaurants.",
    specs: [
      { k: "Motorisation", v: "Turbomeca Arriel" },
      { k: "Vitesse de croisière", v: "245 km/h" },
      { k: "Autonomie", v: "~3 h 30" },
    ],
  },
];

export const EXPERIENCES = [
  {
    id: "initiation",
    number: "01",
    title: "Initiation au pilotage",
    lead:
      "Prenez les commandes. Vol double commande avec instructeur, briefing théorique, débriefing après vol.",
    included: [
      "30 minutes de théorie",
      "Accompagnement instructeur durant tout le stage",
      "Débriefing personnalisé après le vol",
      "Sur Robinson R22 ou R44",
    ],
  },
  {
    id: "bapteme",
    number: "02",
    title: "Baptême de l'air",
    lead:
      "Offrez-vous bien plus qu'un simple vol : une aventure aérienne inoubliable. Admirez les plus beaux paysages de Belgique depuis les airs.",
    included: [
      "Briefing sécurité avant décollage",
      "Vol panoramique au départ de Namur",
      "Jusqu'à 5 passagers sur AS350",
    ],
  },
  {
    id: "vip",
    number: "03",
    title: "Transport VIP",
    lead:
      "Un transport rapide et élégant pour vos déplacements professionnels comme privés.",
    included: [
      "Prise en charge personnalisée",
      "Vol direct partout en Belgique",
      "Confort et prestations haut de gamme",
    ],
    quote: true,
  },
  {
    id: "resto",
    number: "04",
    title: "Transport restaurant",
    lead:
      "Un dîner d'exception, précédé d'un vol d'exception. Nous vous déposons, nous vous récupérons.",
    included: [
      "Étoilés, adresses côtières, châteaux",
      "Coordination sur mesure",
      "Devis à la demande",
    ],
    quote: true,
  },
  {
    id: "mariage",
    number: "05",
    title: "Mariage",
    lead:
      "Une entrée ou une sortie qui ne s'oublie pas. Le jour J, écrit dans le ciel.",
    included: [
      "Décoration florale sur demande",
      "Vidéo & photos coordonnées",
      "Devis sur mesure",
    ],
    quote: true,
  },
  {
    id: "entreprise",
    number: "06",
    title: "Vol entreprise",
    lead:
      "Séminaires, incentives, prise de vue, événements.",
    included: [
      "Multi-passagers, multi-rotations",
      "Reportages aériens possibles",
      "Devis dédié",
    ],
    quote: true,
  },
];

export const PRICING = {
  initiation_r22: [
    { d: "30 min", p: "389 €" },
    { d: "42 min", p: "519 €" },
    { d: "60 min", p: "699 €" },
  ],
  initiation_r44: [
    { d: "18 min", p: "389 €" },
    { d: "30 min", p: "609 €" },
    { d: "42 min", p: "809 €" },
  ],
  bapteme_r22: [
    { d: "30 min", p: "319 €" },
    { d: "42 min", p: "429 €" },
    { d: "60 min", p: "609 €" },
  ],
  bapteme_r44: [
    { d: "18 min", p: "319 €" },
    { d: "30 min", p: "499 €" },
    { d: "42 min", p: "719 €" },
    { d: "60 min", p: "959 €" },
  ],
  bapteme_as350: [
    { d: "30 min", p: "929 €" },
    { d: "42 min", p: "1289 €" },
    { d: "60 min", p: "1829 €" },
  ],
};

export const DESTINATIONS = [
  "Namur",
  "Bruxelles",
  "Liège",
  "Ardennes",
  "Dinant",
  "Bruges",
  "Anvers",
  "Ostende",
  "Spa",
  "Han-sur-Lesse",
  "Waterloo",
  "Malmedy",
];

export const CONTACT = {
  brand: "BSCOPTER",
  domain: "www.bscopter.be",
  email: "info@bscopter.be",
  phone: "+32 491 32 33 47",
  phoneRaw: "0491323347",
  address: "Rue général Leman 51, 4340 Awans",
  base: "Aérodrome de Namur, Belgique",
};

export const NAV_LINKS = [
  { to: "/", label: "Accueil" },
  { to: "/flotte", label: "Flotte" },
  { to: "/experiences", label: "Vols" },
  { to: "/tarifs", label: "Tarifs" },
  { to: "/reservation", label: "Réservation" },
  { to: "/contact", label: "Contact" },
];

export const GALLERY = [
  "https://images.pexels.com/photos/2246476/pexels-photo-2246476.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600",
  "https://images.pexels.com/photos/1309766/pexels-photo-1309766.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600",
  "https://images.pexels.com/photos/12063259/pexels-photo-12063259.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600",
  "https://images.pexels.com/photos/17508699/pexels-photo-17508699.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600",
  "https://images.pexels.com/photos/8828596/pexels-photo-8828596.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600",
  "https://images.pexels.com/photos/1309644/pexels-photo-1309644.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600",
  "https://images.pexels.com/photos/4098365/pexels-photo-4098365.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600",
  "https://images.pexels.com/photos/6980513/pexels-photo-6980513.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600",
];
